import logo from './logo.svg';
import './App.css';
// import HeroSection from './Pages/HomePages/Herosection/HeroSection';
import Homepage from './Pages/HomePages/homepages';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from './layout';
import Connect from "../src/Components/connect/connect"
import Aboutmain from './Pages/Aboutpage/aboutmain';
import ProductCard from './Components/Crystals/Crystals';
import PoojasCard from './Components/Poojas/Poojas';
import Horoscope from './Pages/Horoscope/Horoscope';
import Servicepage from './Pages/ServicePage/Servicepage';
import BookingPage from './Pages/BookingPage/Booking';
import Speciality from './Pages/SpecialityPage/Speciality';
import PrivacyPolicy from './Components/privacypages/PrivacyPolicy';
import RefundPolicy from './Components/privacypages/RefundPolicy';
import TermsConditions from './Components/privacypages/TermsConditions';
function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Layout wraps the nested routes */}
        <Route path="/" element={<Layout />}>

          {/* index means default route for "/" */}
          <Route index element={<Homepage />} />

           <Route path="about" element={<Aboutmain />} />
           <Route path="Crystals" element={<ProductCard />} />
           <Route path="Poojas" element={<PoojasCard />} />
           <Route path="Horoscope" element={<Horoscope />} />
           <Route path="Service" element={<Servicepage />} />
           <Route path="Book-your-slot" element={<BookingPage />} />
           <Route path="Time-Rectification" element={<Speciality />} />
           <Route path="privacypolicy" element={<PrivacyPolicy />} />
           <Route path="refundpolicy" element={<RefundPolicy />} />
           <Route path="terms-and-condition" element={<TermsConditions />} />
        
        </Route>
      </Routes>
      <Connect/>
    </BrowserRouter>
  );
}

export default App;
